import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGamOverviewApp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m41.5 20.8-.7-1.6-1.6-.7q-.3-.15-.3-.5t.3-.5l1.6-.7.7-1.6q.15-.3.5-.3t.5.3l.7 1.6 1.6.7q.3.15.3.5t-.3.5l-1.6.7-.7 1.6q-.15.3-.5.3t-.5-.3Zm-10.2 9.55-1.75-3.9-3.9-1.75q-.45-.2-.45-.7 0-.5.45-.7l3.9-1.75 1.75-3.9q.2-.45.7-.45.5 0 .7.45l1.75 3.9 3.9 1.75q.45.2.45.7 0 .5-.45.7l-3.9 1.75-1.75 3.9q-.2.45-.7.45-.5 0-.7-.45Zm10.2 2.45-.7-1.6-1.6-.7q-.3-.15-.3-.5t.3-.5l1.6-.7.7-1.6q.15-.3.5-.3t.5.3l.7 1.6 1.6.7q.3.15.3.5t-.3.5l-1.6.7-.7 1.6q-.15.3-.5.3t-.5-.3ZM13 46q-1.25 0-2.125-.875T10 43V5q0-1.25.875-2.125T13 2h22q1.25 0 2.125.875T38 5v7.3h-3V9.5H13v29h22v-2.8h3V43q0 1.25-.875 2.125T35 46Z" })
});
export default SvgGamOverviewApp;
